/**
 * useIsAdmin.ts — reads the Entra `Admin` app role off the active account's
 * ID token claims (ADR-084 D3/D6, E12-S3a). UX-only: hides the
 * Persona/Boundaries/Scripts/Facts tabs for a non-Admin operator so they are
 * never shown a control they cannot save. The server is the real gate
 * (`packages/shared/auth/entra.py`, `_require_admin_app_role` in
 * `skill_registry.py`) — this hook must never be treated as authorization.
 */

import { useMsal } from '@azure/msal-react';

const ADMIN_APP_ROLE = 'Admin';

export const useIsAdmin = (): boolean => {
  const { accounts, instance } = useMsal();
  const account = accounts[0] ?? instance.getActiveAccount() ?? undefined;
  const roles = account?.idTokenClaims?.roles;
  return Array.isArray(roles) && roles.includes(ADMIN_APP_ROLE);
};
